import React from 'react';
import styles from './styles/styles.module.css';
import { HashLoader } from 'react-spinners';

interface Props {
  onConfirm: () => void;
  onCancel: () => void;
  headline: string;
  message?: string;
  loading?: boolean;
}

const CustomConfirmationModal: React.FC<Props> = ({
  onConfirm,
  onCancel,
  headline,
  loading,
  message = 'Are you sure you want to save this layout?',
}) => {
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <p className={styles.headline}>{headline}</p>
        <p className={styles.message}>{message}</p>
        <div className={styles.buttonRow}>
          <button className={styles.cancelBtn} onClick={onCancel}>
            Cancel
          </button>
          <button
            className={!loading ? styles.confirmBtn : styles.confirmBtnDisabled}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <HashLoader className={styles.loader} color="white" size={25} />
            ) : (
              'Confirm'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomConfirmationModal;
